import axios from "axios";
import Config from "../../../config";
import "../../../app/custom.scss";
import { setOrmWidgetData, setTicketOffset } from "./Orm";
import {
  sessionExpired,
  callNotification,
  errorCode,
  getUTCOffset,
} from "../../constants";
import { handleApiError, handleAxiosError } from "../../utils/errorHandler";

export const setTicketLoader = (value) => {
  return { type: "SET_TICKET_LOADER", payload: value };
};

export const setTicketWidgetFetch = (authParams, widgetObj) => {
  let finalbrands = widgetObj?.brand_list?.map((el) => {
    return { brand_id: el?.name ? el?.name : el?.brand_id };
  });

  let errorMessage;
  return async (dispatch) => {
    dispatch(setTicketLoader({ value: true, id: widgetObj?.widget_id }));
    if (authParams) {
      let body = {
        ptoken: authParams?.ptoken,
        widget_id: widgetObj?.widget_id,
        interval: widgetObj?.interval, //int value
        chart_type: widgetObj?.chart_type, //string value
        filters: null,
        brand_list: finalbrands,
        start_date: widgetObj?.start_date,
        end_date: widgetObj?.end_date,
        benchmark_breach:
          typeof widgetObj?.benchmark_breach === "string"
            ? 5
            : widgetObj?.benchmark_breach,
        utcoffset: getUTCOffset(),
      };
      let url = `${Config.config1.api_link}/graph/ticket-fetch`;

      // Custom error handlers for specific error codes with business logic
      const customErrorHandlers = {
        9: (errorCodeValue, errorMessage, response, dispatch) => {
          // Session expired - use existing session management
          sessionExpired(true);
          callNotification(errorMessage, "error");

          // Handle widget offset logic for error case
          if (widgetObj?.widget_id === "27") {
            dispatch(setTicketOffset(null));
          } else {
            let index = widgetObj?.ticketOffset?.widget_index;
            let offset = ++index;
            let ticketOffsetObj = {
              widget_index: offset,
              id: widgetObj?.ticketWidgetArray[offset].id,
            };
            dispatch(setTicketOffset(ticketOffsetObj));
          }

          dispatch(
            setOrmWidgetData(
              "No data found",
              widgetObj?.index,
              widgetObj?.ticketWidgetArray
            )
          );
          dispatch(setTicketLoader({ value: false, id: null }));
        },
        default: (errorCodeValue, errorMessage, response, dispatch) => {
          // Default error handling for other error codes including 21
          callNotification(errorMessage, "error");

          // Handle widget offset logic for error case
          if (widgetObj?.widget_id === "27") {
            dispatch(setTicketOffset(null));
          } else {
            let index = widgetObj?.ticketOffset?.widget_index;
            let offset = ++index;
            let ticketOffsetObj = {
              widget_index: offset,
              id: widgetObj?.ticketWidgetArray[offset].id,
            };
            dispatch(setTicketOffset(ticketOffsetObj));
          }

          dispatch(
            setOrmWidgetData(
              "No data found",
              widgetObj?.index,
              widgetObj?.ticketWidgetArray
            )
          );
          dispatch(setTicketLoader({ value: false, id: null }));
        },
      };

      axios
        .post(url, body)
        .then((response) => {
          dispatch({
            type: "SET_TICKET_WIDGET_FETCH",
            payload: response,
          });

          if (response?.data?.status === "successful") {
            dispatch(setTicketLoader({ value: false, id: null }));
            dispatch(
              setOrmWidgetData(
                response?.data?.result,
                widgetObj?.index,
                widgetObj?.ticketWidgetArray
              )
            );

            if (widgetObj?.widget_id === "27") {
              dispatch(setTicketOffset(null));
            } else if (
              widgetObj?.ticketOffset?.id !== "27" &&
              !widgetObj.filter
            ) {
              let index = widgetObj?.ticketOffset?.widget_index;
              let offset = ++index;
              let ticketOffsetObj = {
                widget_index: offset,
                id: widgetObj?.ticketWidgetArray[offset].id,
              };
              dispatch(setTicketOffset(ticketOffsetObj));
            }
          } else if (response?.data?.status === "error") {
            handleApiError(response, dispatch, { customErrorHandlers });
          }
        })
        .catch((error) => {
          dispatch(setTicketLoader({ value: false, id: null }));
          handleAxiosError(error, dispatch, { customErrorHandlers });
        });
    }
  };
};
const setTicketOffsetValue = () => {};
